<template>
  <div class="empty-state-container">
    <div class="empty-state-icon-wrapper">
      <div class="empty-state-icon-circle">
        <i class="pi pi-clock" style="font-size: 4rem; color: #9e9e9e"></i>
      </div>
    </div>
    <h2 class="empty-state-title">{{ title }}</h2>
    <p class="empty-state-description">{{ description }}</p>
  </div>
</template>

<script setup lang="ts">

// Props
interface Props {
  title: string
  description: string
}

defineProps<Props>()
</script>

<style scoped>
.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #9e9e9e;
  overflow: hidden;
  padding: 2rem;
  width: 100%;
}

.empty-state-icon-wrapper {
  margin-bottom: 1.5rem;
}

.empty-state-icon-circle {
  height: 100px;
  width: 100px !important;
  background: #fff;
  width: fit-content;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
}

.empty-state-title {
  text-align: center;
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
  color: #9e9e9e;
}

.empty-state-description {
  text-align: center;
  font-size: 15px;
  margin: 0;
  color: #9e9e9e;
}
</style>